import React from 'react'

import UnsubscribeContainer from '../components/global/UnsubscribeContainer'

export default props => <UnsubscribeContainer />
